/* eslint-disable no-mixed-operators */
import { decoColumns } from "./deco-columns";
import { useState } from "react";

function generateRandomData (count = 10) {
    const statuses = ["paid", "voided"];
  
    const getRandomId = () => Math.floor(Math.random() * (10 ** 10 - 10 ** 6) + 10 ** 6);
  
    const getRandomAmount = () => (Math.random() * 1000).toFixed(2); // up to $1000
  
    const getRandomDate = () => {
        const start = new Date(2020, 0, 1);
        const end = new Date();
        return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime())).toISOString().split("T")[0];
    };
  
    return Array.from({ length: count }, (_, i) => ({
        id    : getRandomId(),
        amount: parseFloat(getRandomAmount()),
        status: statuses[i % statuses.length], // alternating status
        date  : getRandomDate()
    }));
}
  
const useInvoices = () => {

    const [loading] = useState(false);

    return {
        loading,
        invoices: generateRandomData(10),
        columns : decoColumns()
    };
};
export default useInvoices;
